import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

export function useMarketSector(slug: string) {
  const trpc = useTRPC()

  return useQuery(
    trpc.marketSectors.getMarketSector.queryOptions({
      market_sector_id: slug,
    })
  )
}
